export interface ResponseAdministrationOptions {
  estados:               AdministrationStatus[];
  empresas:             AdministrationCompanies[];
  sucursales:            AdministrationBranches[];
  tipos_de_dispositivos: AdministrationTypes[];
  roles:                          AdministrationRoles[];
}

export interface AdministrationStatus {
  id:          string;
  descripcion: string;
}

export interface AdministrationCompanies {
  id:         number;
  nombre:     string;
}

export interface AdministrationBranches {
  id:         number;
  nombre:     string;
  id_empresa: number;
}

export interface AdministrationTypes {
  id:          string;
  descripcion: string;
}

export interface AdministrationRoles {
  id:          number;
  descripcion: string;
}

export interface ResponseBranchesByCompany {
  id: number;
  nombre: string;
}

export interface ResponseCamerasMasterSectorsByBranch {
  camaras_master: AdministrationCamerasMaster[];
  sectores: AdministrationSectors[];
}

export interface AdministrationCamerasMaster {
  id: number;
  nombre: string;
}

export interface AdministrationSectors {
  id: number;
  nombre: string;
}
